import React from 'react'
import IconsAuraExp7 from './Images/IconsAuraExp7.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faCircleChevronRight} from '@fortawesome/free-solid-svg-icons';



function ExpCard7() {
  return (
    

    <div className='ExpPgCard  '>
      
        <p className='ExpPgHExpName'> Holi & Diwali festival </p>

        <p className='ExpPgHCat'> Festival </p>
        <p className='ExpPgHCode'> AURAMUSE107 </p>


        

        <div className='IconsAuraExpDiv'>  <img className='IconsAuraExp' src={IconsAuraExp7} /> </div>

        <FontAwesomeIcon className='FaIconCirc' icon={faCircleChevronRight} size="xl" style={{color: " ", }} />
        

    </div>




  )
}

export default ExpCard7